module.exports = __webpack_public_path__ + "static/media/fatture.c6c1e4c7.svg";